import { render, staticRenderFns } from "./ReadmoreDialog.vue?vue&type=template&id=4c2d3439&scoped=true&lang=html&"
import script from "./ReadmoreDialog.vue?vue&type=script&lang=js&"
export * from "./ReadmoreDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d3439",
  null
  
)

export default component.exports